import { Trans, useTranslation } from 'react-i18next';
import { COMPANY, WEB_API_DOCS_LINKS } from '@/shared/config';
import { useAppSettingsStore } from '@/shared/lib';
import { cn } from '@/shared/utils';
import ReceiptIcon from '@/shared/assets/receipt-ai-icon.svg?react';
import ApiLogoIcon from '@/shared/assets/api-logo-icon.svg?react';
import TradeIcon from '@/shared/assets/trade-icon.svg?react';

export const WebApiTokensContentEmptyState = () => {
  const { t } = useTranslation();
  const { getLanguage } = useAppSettingsStore();

  const docsLink =
    getLanguage() === 'ru' ? WEB_API_DOCS_LINKS.ru : WEB_API_DOCS_LINKS.en;

  const steps = [
    {
      label: t('webApiTokens.emptyState.steps.account'),
      icon: <ReceiptIcon className="size-[2.4rem]" />,
      circleClassName: 'bg-secondary-bg text-primary',
    },
    {
      label: t('webApiTokens.emptyState.steps.token'),
      icon: <ApiLogoIcon className="size-[3.2rem]" />,
      circleClassName: 'bg-primary text-background',
    },
    {
      label: t('webApiTokens.emptyState.steps.service'),
      icon: <TradeIcon className="size-[2.4rem]" />,
      circleClassName: 'bg-secondary-bg text-primary',
    },
  ];

  return (
    <div className="flex flex-col gap-[3.2rem] w-full">
      <div className="flex flex-col gap-[0.8rem] text-center">
        <p className="headline4 text-primary">
          {t('webApiTokens.emptyState.title')}
        </p>

        <p className="p4 text-muted-foreground">
          <Trans
            i18nKey="webApiTokens.emptyState.description"
            values={{ company: COMPANY.name }}
            components={{
              docs: (
                <a
                  href={docsLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary-cyan"
                />
              ),
            }}
          />
        </p>
      </div>

      <div className="relative flex justify-between w-[32rem] mx-auto pb-[1.7rem]">
        <div className="absolute top-[3.2rem] inset-x-[7.2rem] h-px bg-[repeating-linear-gradient(to_right,var(--stroke)_0_3px,transparent_3px_6px)]" />

        {steps.map(({ label, icon, circleClassName }) => (
          <div
            key={label}
            className="relative flex flex-col items-center gap-[0.9rem] w-[6.4rem]">
            <div
              className={cn(
                'flex items-center justify-center size-[6.4rem] rounded-full',
                circleClassName
              )}>
              {icon}
            </div>

            <span className="medium5 text-primary whitespace-nowrap">
              {label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
